import { skipToken, useQuery } from '@tanstack/react-query';
import { getV1CompaniesCompanyIdInvoicesInvoiceIdPayCommissionPresentation } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';

import { PayCommissionPresentation } from '~hooks/useInvoiceLineItems/models';
import connection from '~services/connectionModule';

import { PAY_COMMISSION_PRESENTATION_QUERY_KEY } from './constants';

interface UsePayCommissionPresentationQueryProps {
  companyId: string;
  invoiceId: string;
  isEnabled: boolean;
  materialRateItemized: boolean;
}

export default function usePayCommissionPresentationQuery({
  companyId,
  invoiceId,
  isEnabled,
  materialRateItemized,
}: UsePayCommissionPresentationQueryProps) {
  const { data, isFetching } = useQuery({
    queryKey: [
      PAY_COMMISSION_PRESENTATION_QUERY_KEY,
      companyId,
      invoiceId,
      materialRateItemized,
    ],
    queryFn:
      isEnabled && companyId
        ? async ({ signal }) => {
            try {
              const response =
                await getV1CompaniesCompanyIdInvoicesInvoiceIdPayCommissionPresentation({
                  path: { 'company-id': companyId, 'invoice-id': invoiceId },
                  query: { material_rate_itemized: materialRateItemized },
                  signal,
                });

              return PayCommissionPresentation.parse(response.data.data);
            } catch (error) {
              connection.handleRequestError(
                error,
                t('error_messages.invoices.failed_to_fetch_pay_commission_presentation'),
              );
              throw error;
            }
          }
        : skipToken,
  });

  return { isFetching, presentation: data };
}
